import { Button } from "antd";
import Play from "icons/Play.svg";
import Pause from "icons/Pause.svg";
import FrameDown from "icons/minus.svg";
import FrameUp from "icons/FrameUp.svg";
import PlayDisabled from "icons/PlayDisabled.svg";
import PauseDisabled from "icons/PauseDisabled.svg";
import FrameDownDisabled from "icons/FrameDownDisabled.svg";
import FrameUpDisabled from "icons/FrameUpDisabled.svg";
import { ReactComponent as MinusIcon } from "icons/minusIcon.svg";

import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { ConditionalRenderer } from "components/conditonal-renderer";
import {
  BaseballLandPosition,
  BaseballLiftPoisiton,
  BaseballSetPosition,
} from "components/baseball-seek-bar/icons";

export function SeekBarMulti({
  isReadyToPlay,
  handlePlay,
  isPlaying,
  handlePreviousFrame,
  timestamps,
  currentFrame,
  handleSliderChange,
  handleNextFrame,
  isControlsDisabled,
  hideSeekbar,
  isLandscape,
  isDrawing,
  min,
  max,
  variant,
  setCurrentFrame,
  positions,
  playbackSpeed,
  handlePlayBackSpeed,
  playbackMode,
}: any) {
  const [width, setWidth] = useState<any>();
  useEffect(() => {
    const widthOfInput = document?.getElementById("range")?.clientWidth || 0;
    setWidth(widthOfInput);
  }, []);

  const widthOfIconsContainer = width;

  let marginBox = 1;
  const sizeofIcon = 50;

  // formula to find the center of icon box
  if (width) {
    marginBox = ((sizeofIcon / width) * 100) / 2;
  }
  const containerClassName = styles.seekbarColumn;
  const drawingLandscape = isLandscape && isDrawing ? true : false;

  function isMinusBtnDisabled() {
    if (variant === "onlyDisplayP7" && positions) {
      return currentFrame <= positions["P7"] - 6;
    }
    if (currentFrame <= 0) return true;
  }

  function isPlusBtnDisabled() {
    if (variant === "launch") {
      if (currentFrame >= max) return true;
    }
    if (variant === "onlyDisplayP7" && positions) {
      return currentFrame >= positions["P7"] + 6;
    }
    return timestamps ? currentFrame >= timestamps.length - 1 : false;
  }

  function getBaseballCriticalEvents(positions: any) {
    if (!positions) return;
    return [
      {
        key: "P1",
        positionFrame: positions["P1"],
        icon: BaseballSetPosition,
        adjustmentFactor: 0.6,
      },
      {
        key: "P7",
        positionFrame: positions["P7"],
        icon: BaseballLiftPoisiton,
        adjustmentFactor: 0,
      },
      {
        key: "P10",
        positionFrame: positions["P10"],
        icon: BaseballLandPosition,
        adjustmentFactor: 0,
      },
    ];
  }

  const baseballCriticalEvents = getBaseballCriticalEvents(positions);
  function handleClickPositionIcon(frameNum: any) {
    setCurrentFrame(frameNum);
  }

  return (
    <>
      <div className={containerClassName}>
        <div
          style={{
            height: "30px",
            width: "30px",
            cursor: "pointer",
            pointerEvents: currentFrame <= min ? "none" : "auto",
          }}
          className={styles.minusBtn}
        >
          <MinusIcon height={30} width={30} onClick={handlePreviousFrame} />
        </div>
        <ConditionalRenderer condition={playbackMode === "smooth"}>
          <button
            style={{
              height: "30px",
              width: "30px",
              borderRadius: "50%",
              backgroundColor: "#006ab3",
              color: "white",
              border: "none",
              outline: "none",
              flexShrink: "0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => handlePlayBackSpeed(playbackSpeed)}
          >
            {playbackSpeed}
          </button>
        </ConditionalRenderer>
        {/* <Button
              onClick={handlePreviousFrame}
              disabled={isMinusBtnDisabled()}
              className={styles.frameButton}
            >
              <img
                src={isControlsDisabled ? FrameDownDisabled : FrameDown}
                alt=""
                style={{ height: "25px", width: "20px" }}
              />
            </Button> */}
        <Button
          className={styles.rangeBtn}
          onClick={handlePlay}
          disabled={isControlsDisabled}
          style={{ border: "none" }}
        >
          <img
            src={isPlaying ? Pause : Play}
            alt="play-pause-icon"
            style={{ height: "30px" }}
          />
        </Button>

        <input
          type="range"
          id="range"
          min={min || 0}
          max={max || (timestamps ? timestamps.length - 1 : 100)}
          value={currentFrame}
          onChange={handleSliderChange}
          disabled={isControlsDisabled}
        />
        <div
          className={styles.criticalEventsContainer}
          style={{
            width: `${widthOfIconsContainer}px`,
            transform: "translate(-49%, 0)",
            left: "50%",
          }}
        >
          {baseballCriticalEvents?.map((item, index) => {
            const Icon = item.icon;
            // const adjustmentFactor = index === 0 ? 0.3 : 0;
            return (
              <ConditionalRenderer condition={item.positionFrame && positions}>
                <div
                  key={item.key}
                  onClick={() => handleClickPositionIcon(item.positionFrame)}
                  className={`${styles.positionsIcon} ${styles.frameOnSeekbar}`}
                  style={{
                    left: `${
                      ((item.positionFrame - min) / (max - min)) * 100 -
                      marginBox +
                      item?.adjustmentFactor
                    }%`,
                  }}
                >
                  {item.key}
                </div>
                {/* <Icon
                  key={item.key}
                  onClick={() => handleClickPositionIcon(item.positionFrame)}
                  className={styles.positionsIcon}
                  style={{
                    left: `${
                      ((item.positionFrame - min) / (max - min)) * 100 -
                      marginBox +
                      item?.adjustmentFactor
                    }%`,
                  }}
                /> */}
              </ConditionalRenderer>
            );
          })}
        </div>
        <Button
          onClick={handleNextFrame}
          disabled={isPlusBtnDisabled()}
          className={styles.rangeBtn}
        >
          <img
            src={isControlsDisabled ? FrameUpDisabled : FrameUp}
            alt=""
            height={30}
          />
        </Button>
      </div>
    </>
  );
}
